// extracted by mini-css-extract-plugin
module.exports = {"GistCard":"GistDetailsView_GistCard__1PCBT"};